import { allThemes, Box, ColorOptions, Text, TextProps } from '@jfs/ui-new'
import { FC, useEffect, useState } from 'react'
import { styles } from './styles'

interface ResendProps {
  count?: number
  mobile?: string
  handleResend: (mobile: string) => void
}

const cdtStyles = (resendOtpColor: string) => {
  return {
    resendText: {
      fontSize: 12,
      fontWeight: 'FONT_WEIGHT_MEDIUM',
      color: resendOtpColor,
    } as TextProps,
  }
}

const getCountDownTime = (cdtimer: number) => {
  return cdtimer > 0 ? (cdtimer < 10 ? ` (0${cdtimer}` : ` (${cdtimer}`) : ''
}

const Resend: FC<ResendProps> = ({ count = 0, mobile, handleResend }: ResendProps) => {
  const [countDowntimer, setCountDownTimer] = useState(count)

  useEffect(() => {
    let timer: any
    if (countDowntimer > 0) {
      timer = setInterval(() => setCountDownTimer(countDowntimer - 1), 1000)
    }
    return () => clearInterval(timer)
  }, [countDowntimer])

  const resendOtpColor = countDowntimer > 0 ? allThemes.light.colors.GRAY_LIGHT : allThemes.light.colors.BLUE

  const onResendOtp = () => {
    if (countDowntimer <= 0) {
      setCountDownTimer(count)
      if (mobile?.length === 10) {
        handleResend(mobile)
      }
    }
  }

  return (
    <Box
      onPress={onResendOtp}
      {...styles.resendTouchable}
      testID={countDowntimer > 0 ? "resend-otp-disabled" : "resend-otp-enabled"}
      underlayColor={allThemes.light.colors.TRANSPARENT as ColorOptions}>
      <>
        <Box {...styles.resendContainer}>
          <Text {...cdtStyles(resendOtpColor).resendText} >
            Resend OTP
          </Text>
          <Text {...styles.countStyle} >{`${getCountDownTime(countDowntimer)}${countDowntimer !== 0 ? 's)' : ''
            }`}</Text>
        </Box>
      </>
    </Box>
  )
}

export { Resend }
